import { SVGProps } from "react";
const EmojiBlackSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#52575D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.504 5.997v-3M18.004 4.497h3.001M8.5 8.999v1M15.504 8.999v1M15.503 14.69a5.326 5.326 0 0 1-7.003 0"
    />
    <path
      stroke="#52575D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.585 9.352c.274.856.415 1.749.419 2.648A9.004 9.004 0 1 1 12 2.996a8.842 8.842 0 0 1 2.648.418"
    />
  </svg>
);
export default EmojiBlackSvg;
